import { applyAuth0Theme } from "@/utils/theme";

import MfaEmailChallengeForm from "./components/MfaEmailChallengeForm";
import { useMfaEmailChallengeManager } from "./hooks/useMFAEmailChallengeManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MFAEmailChallengeScreen() {
    // Extracting attributes from hook made out of MFAEmailChallengeInstance class of Auth0 React SDK
    const { mfaEmailChallenge, texts, locales } = useMfaEmailChallengeManager();

    // Apply theme from SDK instance when screen loads
    applyAuth0Theme(mfaEmailChallenge);
    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>

            <MfaEmailChallengeForm />
            </AuthLayout>
    );
}

export default MFAEmailChallengeScreen;
